import { useForm } from "react-hook-form";
import { useParams } from "react-router";

import { PreviewExperience } from "@/components/sku/preview-experience";
import { Form } from "@/components/ui/form";
import { CMSContent } from "@/components/web-experience/cms-content";
import { CMSProvider } from "@/components/web-experience/cms-context";
import { CMSHeader } from "@/components/web-experience/cms-header";
import { useGetSKUQuery } from "@/data/queries";
import { getPreviewParamsFromSKU } from "@/lib/preview";

export const WebExperience = () => {
  const { skuId } = useParams<{ skuId: string }>();
  const { isPending, data: sku } = useGetSKUQuery(skuId!);
  const form = useForm();

  if (isPending) return <div />;

  if (!sku) {
    return <div>SKU not found</div>;
  }

  return (
    <CMSProvider sku={sku}>
      <Form {...form}>
        <div className="h-screen flex flex-col overflow-hidden">
          <CMSHeader skuId={sku.id} skuName={sku.name} />
          <div className="h-min flex flex-1 overflow-hidden">
            <CMSContent skuId={sku.id} />
            <div className="px-18 pt-15">
              <PreviewExperience params={getPreviewParamsFromSKU(sku)} />
            </div>
          </div>
        </div>
      </Form>
    </CMSProvider>
  );
};
